<template>
	<div class='knd-tooltip' 
		v-show="showTooltip" 		
		v-bind:style="{ 'left': tooltipXpos +'px', 'top': tooltipYpos +'px'}"
	>
		<div class='knd-tooltip__container' ref='tooltip'>
			<slot></slot>
		</div>
	</div>

</template>

<script>
	import './tooltip.scss'

export default {

	name: 'tooltip',
	props: ['tooltip', 'showTooltip'],

	data: function() {
		return {
			tooltipYpos: 0,
			tooltipXpos: 0
		}
	},

	watch: {
		'showTooltip': function (val, oldVal) {

			if(!val) return;

				this.$nextTick(() => {
					let padding = 15;
					let tooltipWidth = this.$refs.tooltip ? this.$refs.tooltip.offsetWidth : 0;
					const { height } = this.$refs.tooltip.getBoundingClientRect();

					const left = this.clamp(
							padding,
							this.tooltip.x - (tooltipWidth /2),
							window.innerWidth - tooltipWidth - padding
						);

					const top =
						window.innerHeight > this.tooltip.y + padding + height
						? this.tooltip.y + padding
						: this.tooltip.y - height - padding;


					this.tooltipYpos = top;
					this.tooltipXpos = left;
				});


		}
	},

	methods:  {
		clamp(min, d, max) {
			return Math.max(min, Math.min(max, d));
		}

	}

}
</script>

<style lang="css" scoped>
</style>